import { useState } from 'react';
import cn from 'classnames';
import styles from './ChatMessage.module.scss';
import { Modal } from '~/components/Shared/Modal/Modal';

interface ChatMessageImage {
  id: number;
  full_photo_url: string;
}

interface ChatMessageVideo {
  id: number;
  full_video_url: string;
  full_preview_url: string;
}

interface ChatMessageProps {
  description: string;
  isMyComment: boolean;
  time: string;
  images?: ChatMessageImage[];
  videos?: ChatMessageVideo[];
}

export const ChatMessage = ({
  description,
  isMyComment,
  time,
  images = [],
  videos = [],
}: ChatMessageProps) => {
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  return (
    <>
      <div
        className={cn(styles.wrapper, {
          [styles.right]: isMyComment,
          [styles.left]: !isMyComment,
        })}
      >
        <div
          className={cn(styles.bubble, {
            [styles.myMessage]: isMyComment,
            [styles.otherMessage]: !isMyComment,
          })}
        >
          {description && <div className={styles.text}>{description}</div>}

          {images.length > 0 && (
            <div className={styles.images}>
              {images.map(img => (
                <img
                  key={img.id}
                  src={img.full_photo_url}
                  alt=""
                  className={styles.imageThumb}
                  onClick={() => setPreviewImage(img.full_photo_url)}
                />
              ))}
            </div>
          )}

          {videos.length > 0 && (
            <div className={styles.videos}>
              {videos.map(vid => (
                <video
                  key={vid.id}
                  src={vid.full_video_url}
                  poster={vid.full_preview_url}
                  controls
                  className={styles.video}
                />
              ))}
            </div>
          )}

          <div className={styles.time}>{time}</div>
        </div>
      </div>

      {previewImage && (
        <Modal isOpen={true} onClose={() => setPreviewImage(null)}>
          <img
            src={previewImage}
            alt=""
            style={{ maxWidth: '90vw', maxHeight: '80vh', objectFit: 'contain' }}
          />
        </Modal>
      )}
    </>
  );
};
